<template>
  <a-flex vertical gap="large">
    <a-radio-group
      :value="currentRouteName"
      @change="handleRouteChange"
      button-style="solid"
    >
      <a-radio-button value="combineProductsBySize">
        Объединение по размерам
      </a-radio-button>

      <a-radio-button value="combineProductsByVariant" :disabled="true">
        Объединение номенклатур / цветов / вариантов
      </a-radio-button>
    </a-radio-group>

    <router-view />
  </a-flex>
</template>

<script setup lang="ts">
import { useRouter } from "vue-router";
import { computed } from "vue";

const router = useRouter();

const currentRouteName = computed(() => router.currentRoute.value.name);

const handleRouteChange = (event: Event) => {
  const target = event.target as HTMLInputElement;
  const value = target.value;

  if (value !== currentRouteName.value) {
    router.push({ name: value });
  }
};
</script>

<style scoped lang="scss">
.ant-radio-group {
  display: flex;
  max-width: 50%;
  align-self: center;
  width: 100%;

  & > .ant-radio-button-wrapper {
    flex: 1 1 0;
    white-space: nowrap;
    text-align: center;
  }
}
</style>
